import { c as _c } from "react/compiler-runtime";
export const DiscountTag = t0 => {
  const $ = _c(3);
  const {
    discount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg aria-hidden="true" className="absolute inset-0 h-full w-full" viewBox="0 0.0442 95 23" fill="none" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M10.0693 0.0440484C10.0693 0.0832913 10.0219 0.102944 9.99414 0.0751954L9.96299 0.0440484C9.93867 0.0197211 9.89922 0.0197212 9.8749 0.0440485L1.17193 8.74701C-0.390165 10.3091 -0.390166 12.8418 1.17193 14.4039L9.81226 23.0442C9.87118 23.1031 9.96671 23.1031 10.0256 23.0442C10.0539 23.0159 10.0923 23 10.1323 23H90.0693C92.2785 23 94.0693 21.2091 94.0693 19V4C94.0693 1.79086 92.2785 0 90.0693 0H10.1134C10.0891 0 10.0693 0.0197211 10.0693 0.0440484Z" fill="currentColor" /></svg>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== discount) {
    t2 = <span className="relative ml-1 inline-flex items-center py-1 pr-3 pl-4 text-sm font-semibold text-green-700">{t1}<span className="relative text-white">SAVE {discount}%</span></span>;
    $[1] = discount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default DiscountTag;